export default "__VITE_ASSET__7bn1$nyn__"